export interface Sidebar {
    width: number;
}

const sidebar: Sidebar = {
    width: 18.125,
};

export default sidebar;
